<footer>
  <div class="footer-image">
    <img src="assets/img/VigiladoSuperIntendencia.png" alt="fsd" />
  </div>
  <div class="footer-bar"></div>
  <div class="footer-content">
    <p>Copyright © Todos los derechos reservados {{ currentYear }}. - v.{{ version }}</p>
  </div>
</footer>
